import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

function CambioEstado({ idSolicitud, estadoActualId }) {
  const cookie = new Cookies();

  const [modalIsOpen, setIsOpen] = useState(false);
  const [estados, setEstados] = useState([]);
  const [postEstado, setPostEstado] = useState("");
  const [postEstadoId, setPostEstadoId] = useState(null);
  const [justificacion, setJustificacion] = useState("");
  const [loadingEstados, setLoadingEstados] = useState(false);
  const [saving, setSaving] = useState(false);

  const usuarioId = cookie.get("id");

  const authConfig = {
    auth: {
      username: "BasicAuth@icontec.org",
      password: "yQLzqmR7eZSuAmQZUqhY",
    },
  };

  // ==============================
  // Abrir modal y cargar estados
  // ==============================
  const handleOpenModal = () => {
    setIsOpen(true);
    obtenerEstados();
  };

  const closeModal = () => {
    setIsOpen(false);
    setPostEstado("");
    setPostEstadoId(null);
    setJustificacion("");
  };

  // ==============================
  // Obtener tipos de estado
  // ==============================
  const obtenerEstados = async () => {
    try {
      setLoadingEstados(true);

      const response = await axios.get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerTipoEstadosSolicitud/" +
          cookie.get("id"),
        authConfig,
      );

      setEstados(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudieron cargar los estados.", "error");
    } finally {
      setLoadingEstados(false);
    }
  };

  // ==============================
  // Guardar cambio de estado
  // ==============================
  const postUpdate = async (e) => {
    e.preventDefault();

    if (saving) return;

    if (!postEstadoId) {
      Swal.fire("Atención", "Debe seleccionar un estado.", "warning");
      return;
    }

    if (!justificacion.trim()) {
      Swal.fire(
        "Atención",
        "Debe ingresar la justificación del estado.",
        "warning",
      );
      return;
    }

    try {
      setSaving(true);

      Swal.fire({
        title: "Procesando...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      // ==============================
      // 1️⃣ Crear Justificación
      // ==============================
      const justificacionResponse = await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/creaJustificacionesEstado",
        {
          Justificacion: justificacion,
          SolicitudId: idSolicitud,
          UsuarioId: usuarioId,
          EstadoAnteriorId: 1,
          EstadoNuevoId: postEstadoId,
        },
        authConfig,
      );

      const idJustificacion =
        justificacionResponse.data?.id ||
        justificacionResponse.data?.Id ||
        justificacionResponse.data;

      if (!idJustificacion) {
        throw new Error("No se obtuvo idJustificacion");
      }

      // ==============================
      // 2️⃣ Actualizar Solicitud
      // ==============================
      const updateResponse = await axios.put(
        `https://suadesarrollo.azurewebsites.net/api/ActualizaSolicitudes/${idSolicitud}/${usuarioId}/${idJustificacion}`,
        {
          Estado: postEstado,
          TipoEstadoId: postEstadoId,
        },
        authConfig,
      );

      const data = updateResponse.data;

      console.log("Respuesta Update:", data);

      // ==============================
      // 🔥 MENSAJE PERSONALIZADO
      // ==============================
      Swal.fire({
        title: "Solicitud actualizada",
        icon: "success",
        html: `
    <p>${data.mensaje}</p>
    <hr/>
    <p>
      La solicitud estaba en estado 
      <b style="color:#dc3545">${data.estadoAnterior}</b>
      y pasó a estado 
      <b style="color:#28a745">${data.estadoNuevo}</b>.
    </p>
  `,
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload(); // 🔥 recarga la página
        }
      });

      closeModal();
    } catch (error) {
      console.error("Error completo:", error);
      console.log("Error response:", error.response);
      console.log("Error data:", error.response?.data);

      Swal.fire(
        "Error",
        JSON.stringify(error.response?.data || error.message, null, 2),
        "error",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <button className="btn btn-dark" onClick={handleOpenModal}>
        {cookie.get("tipo_Usuario") == 2 ? <a>Finalizar</a> : <a>Estado</a>}
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Actualizar Estado"
        ariaHideApp={false}
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Actualizar Estado
              </h6>
            </div>
            {cookie.get("tipo_Usuario") == 2 ? (
              <strong>
                Si usted es una institución y acaba de finalizar su
                autoevaluación, por favor marque el estado “En revisión” y
                agregue una breve justificación de su finalización.
              </strong>
            ) : (
              <l></l>
            )}
            <div className="card-body">
              <form onSubmit={postUpdate}>
                {/* SELECT ESTADO */}
                <div className="form-group">
                  <select
                    className="form-control"
                    value={postEstadoId || ""}
                    disabled={loadingEstados}
                    onChange={(e) => {
                      const selected = estados.find(
                        (est) => est.id == e.target.value,
                      );

                      setPostEstadoId(Number(e.target.value));
                      setPostEstado(selected?.nombre || "");
                    }}
                  >
                    <option value="">
                      {loadingEstados
                        ? "Cargando estados..."
                        : "Seleccione nuevo estado"}
                    </option>

                    {estados.map((estado) => (
                      <option key={estado.id} value={estado.id}>
                        {estado.nombre}
                      </option>
                    ))}
                  </select>
                </div>

                {/* JUSTIFICACIÓN */}
                <div className="form-group mt-3">
                  <label>
                    <b>Justificación del estado</b>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Escriba la justificación..."
                    value={justificacion}
                    onChange={(e) => setJustificacion(e.target.value)}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-block mt-3"
                  disabled={saving}
                >
                  {saving ? "Guardando..." : "Guardar"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CambioEstado;
